// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import './assets/less/common.less'
import './assets/js/rem'
import 'font-awesome/css/font-awesome.css'
import components from './components/index'
import store from './store/index'
import '@/utils/filter'
import api from '@/assets/js/api/index.js'
import { postAction, getAction } from '@/assets/js/api/manage'
import {Modal} from 'view-design'
import './assets/css/alibaba-font.css'
import { install as installSecureImageDirective } from '@/directives/secureImage'
Vue.config.productionTip = false

Vue.use(ViewUI)
Vue.use(components)
// 注册防盗链图片指令
installSecureImageDirective(Vue)
Vue.prototype.$api = api
Vue.prototype.$isLogin = function() {
  let username = localStorage.getItem('username')
  if(!username) {
    Modal.error({
      title: '对不起',
      content: '您尚未登录，请先登录后操作',
      onOk: () => {
        sessionStorage.setItem('redirect', router.currentRoute.fullPath)
        router.push('/login')
      }
    })
    return false
  } else {
    return true
  }
}
window.postAction = postAction
window.getAction = getAction
window.tabs = ['首页']
/* eslint-disable no-new */
console.log(components)
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js